import React, { useEffect } from 'react';
import cx from 'classnames'
import './ListeningStatusMicUI.scss'
import { connect } from 'react-redux';
import get from 'lodash.get';

function ListeningStatusMicUI({isListening}){

    useEffect(() => {
        console.log('Mic UI isListening:', isListening)
    }, [isListening])

    let micIconClassNames = cx({
        "mic-icon": true,
        active: isListening,
        inactive: !isListening
    })

    return <div className="listeningStatusContainer">
        <div className='mic-ui'>
        <div className='mic-background'>
            <div className={micIconClassNames}>
            </div>
        </div>
    </div>
    </div>
}

const mapStateToProps = state => {
    return {
        isListening: get(state, 'speech.listener.isListening', null),
    }
};
  
export default connect(mapStateToProps)(ListeningStatusMicUI);
  
  